import { useAtom } from "jotai";
import React from "react";
import { loadingAtom } from "../store";
import Loader from "./Loader";

const PageLoader = () => {
  const [loading] = useAtom(loadingAtom);
  if (!loading) return null;
  return (
    <div className="page-loader">
      <Loader />
    </div>
  );
};

export default PageLoader;
